<template>
  <b-card-body>
    <img
      src="img/logo.png"
      class="img-avatar"
      alt="Moviment Graffitti Logo"
    />
    <p class="m-5">
      Welcome!! Want to register contact support!!
    </p>
  </b-card-body>
</template>

<script>
  export default {
      name: "welcome-card",
  }
</script>
